import type { ConnectProperty } from 'bundles/connect/types';

// Every bookmark has its Insights id; `propertyId` comes from the Insights record and is missing when that record
// didn't come back, so it can't tell rows apart.
export const propertyKey = (property: ConnectProperty) => property.insightsPropertyId;
